import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Lock, Zap, BarChart3 } from 'lucide-react';
export function MechanismSection() {
  const phases = [{
    days: '7 DÍAS',
    title: 'RESET',
    desc: "Bajas el ruido y recuperas tolerancia al aburrimiento productivo. Sin drama. Sin 'desaparecer'. Con reglas claras.",
    icon: Lock,
    color: 'text-blue-400'
  }, {
    days: '14 DÍAS',
    title: 'ESTRUCTURA MÍNIMA',
    desc: "Construyes una rutina que sobrevive turnos. No la rutina 'ideal'. La rutina que se hace.",
    icon: Zap,
    color: 'text-blue-500'
  }, {
    days: '30 DÍAS',
    title: 'EJECUCIÓN',
    desc: "Reglas no negociables + trackers + output medible. Aquí dejas de 'intentarlo' y empiezas a cumplir.",
    icon: BarChart3,
    color: 'text-blue-600'
  }];
  return <section className="py-32 px-6 bg-[#0a0a0a]" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        <FadeIn className="text-center mb-20" data-id="element-37">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tighter" data-id="element-38">
            ARQUITECTURA <span className="text-blue-600" data-id="element-39">7–14–30</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-40">
            LOCK IN no es inspiración. Es una arquitectura que te lleva de
            distracción crónica a ejecución sostenida.
          </p>
        </FadeIn>

        <div className="relative" data-id="element-41">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-gradient-to-r from-blue-900 via-blue-600 to-blue-400 opacity-30" data-id="element-42" />

          <div className="grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-43">
            {phases.map((phase, i) => <FadeIn key={i} delay={0.2 + i * 0.2} className="relative" data-id="element-44">
                <div className="bg-[#111] border border-white/10 p-8 h-full hover:border-blue-600/30 transition-colors duration-300 group" data-id="element-45">
                  <div className="absolute -top-6 left-1/2 -translate-x-1/2 md:left-8 md:translate-x-0 bg-[#0a0a0a] p-2 border border-blue-900/50 rounded-full z-10" data-id="element-46">
                    <phase.icon className={`w-8 h-8 ${phase.color}`} data-id="element-47" />
                  </div>

                  <div className="mt-6 text-center md:text-left" data-id="element-48">
                    <span className={`inline-block text-sm font-bold tracking-widest mb-2 ${phase.color}`} data-id="element-49">
                      FASE {i + 1}: {phase.days}
                    </span>
                    <h3 className="text-2xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-50">
                      {phase.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed" data-id="element-51">
                      {phase.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}